var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8914",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8914",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u4EA4\\u5DEE_3",
    "data-name": "\\u4EA4\\u5DEE 3",
    d: "M3.456,9.587V7.025A4.693,4.693,0,0,0,5.492,3.947H0V0H9.61A11.632,11.632,0,0,1,9.8,2.087a9.952,9.952,0,0,1-3.043,7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u4EA4\\u5DEE_6",
    "data-name": "\\u4EA4\\u5DEE 6",
    d: "M0,2.644V0H3.409a6.082,6.082,0,0,0,5.71,4.206,6.137,6.137,0,0,0,3.456-.975l3.3,2.561A9.743,9.743,0,0,1,9.119,8.265,10.2,10.2,0,0,1,0,2.644Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u4EA4\\u5DEE_9",
    "data-name": "\\u4EA4\\u5DEE 9",
    d: "M0,4.583A10.216,10.216,0,0,1,1.085,0H4.494V2.644a6.044,6.044,0,0,0,0,3.878L1.085,9.165A10.219,10.219,0,0,1,0,4.583Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u4EA4\\u5DEE_12",
    "data-name": "\\u4EA4\\u5DEE 12",
    d: "M0,5.621A10.2,10.2,0,0,1,9.119,0a9.811,9.811,0,0,1,6.828,2.657L13.019,5.584a5.512,5.512,0,0,0-3.9-1.525,6.082,6.082,0,0,0-5.71,4.207Z",
    fill: "none"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_1435",
    "data-name": "\\u6955\\u5186\\u5F62 1435",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8891",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8891",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8890",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8883",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8883",
    transform: "translate(10.204 8.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8882",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8882",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8435",
    "data-name": "\\u9577\\u65B9\\u5F62 8435",
    width: 21.134,
    height: 20.925,
    transform: "translate(-5.669 -5.669)",
    fill: "#3e82f1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8885",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8885",
    transform: "translate(1.085 12.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8884",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8884",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8438",
    "data-name": "\\u9577\\u65B9\\u5F62 8438",
    width: 27.21,
    height: 19.603,
    transform: "translate(-5.668 -5.669)",
    fill: "#32a753"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8887",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8887",
    transform: "translate(0 5.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8886",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8886",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8441",
    "data-name": "\\u9577\\u65B9\\u5F62 8441",
    width: 15.832,
    height: 20.503,
    transform: "translate(-5.669 -5.669)",
    fill: "#f9bb00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8889",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8889",
    transform: "translate(1.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8888",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8888",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8444",
    "data-name": "\\u9577\\u65B9\\u5F62 8444",
    width: 27.284,
    height: 19.603,
    transform: "translate(-5.668 -5.669)",
    fill: "#e74133"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0a285eb2c2cb112cd8f556b71a2b4ccc.svg";
export { ForwardRef as ReactComponent };